import "../styles/App.css";
import "../styles/pages/Contacts.css";

import ContactList from "../components/ContactList";
import Carousel from "../components/ImageCarousel";
import useIsMobile from "../hooks/useIsMobile";

const loadImages = () => {
  const images = [
    "/images/outside1.png",
    "/images/outside2.png",
    "/images/outside3.png",
    "/images/outside4.png",
  ]

  return (images.map((img, idx) => {
    return (
      <a className="contact" href={"https://maps.app.goo.gl/ZmTG4a9YHiFSyCBH8"} target="_blank" rel="noreferrer">

      <img
        key={`slide-${idx}`}
        className="contactSlide"
        src={img}
        alt={`slide ${idx}`}
      />
      </a>
    )
  }))
}

function Contacts() {
  const isMobile = useIsMobile(801);
  return (
    <div id="contacts" className="section">
      <div className="contactsWrapper">
          {isMobile? undefined: <Carousel items={loadImages()}/>}
          <ContactList />
      </div>
    </div>
  );
}

export default Contacts;
